import { Routes } from '@angular/router';
import { PageNotFoundComponent } from '@features/page-not-found.component';
import { AGENT_CHAT_ROUTE } from '@features/agent-chat/agent-chat.routes';
import { AUDIENCE_ROUTE } from '@features/audience/audience.routes';
import { AUTOMATION_ROUTES } from '@features/automation/automation.routes';
import { CAMPAIGNS_ROUTE } from '@features/campaigns/campaigns.routes';
import { INBOX_ROUTE } from '@features/inbox/inbox.routes';
import { INSIGHTS_ROUTE } from '@features/insights/insights.routes';
import { subscriptionLevelGuard } from '@features/settings/billing/guards/subscription-level.guard';
import { subscriptionGuard } from '@features/settings/billing/guards/subscription.guard';
import { INTEGRATIONS_ROUTE } from '@features/settings/integrations/integrations.routes';
import { SETTINGS_ROUTES } from '@features/settings/settings.routes';
import { TEMPLATES_ROUTES } from '@features/templates/templates.routes';
import { TICKET_ROUTES } from '@features/ticket/ticket.routes';
import { COMMERCE_ROUTES } from '@routes/commerce.routes';
import { APP_SLUGS, MAIN_SLUGS, SETTINGS_SLUGS } from '@routes/routes.types';

export const MAIN_ROUTES: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: MAIN_SLUGS.DASHBOARD,
    },
    //
    {
        path: MAIN_SLUGS.DASHBOARD,
        title: 'Dashboard',
        loadComponent: () =>
            import('@features/dashboard/dashboard.component').then(m => m.DashboardComponent),
        canActivate: [subscriptionGuard],
    },
    AUDIENCE_ROUTE,
    INBOX_ROUTE,
    CAMPAIGNS_ROUTE,
    {
        path: MAIN_SLUGS.integrations,
        children: [INTEGRATIONS_ROUTE],
        canActivate: [subscriptionGuard],
    },
    {
        path: MAIN_SLUGS.commerce,
        loadComponent: () =>
            import('@features/audience/audience.component').then(m => m.AudienceComponent),
        canActivate: [subscriptionGuard],
        children: COMMERCE_ROUTES,
    },
    {
        path: MAIN_SLUGS.SETTINGS,
        title: 'Settings',
        children: SETTINGS_ROUTES,
    },
    // Social analytics is hidden (US-5): its code stays, but the old URLs
    // (the section and any of its sub-routes) land on the dashboard.
    {
        path: MAIN_SLUGS.SOCIAL_ANALYTICS,
        children: [{ path: '**', redirectTo: `/${APP_SLUGS.MAIN}/${MAIN_SLUGS.DASHBOARD}` }],
    },
    INSIGHTS_ROUTE,
    {
        path: MAIN_SLUGS.automate,
        loadComponent: () =>
            import('@features/automation/automation-layout/automation-layout.component').then(
                m => m.AutomationLayoutComponent
            ),
        children: AUTOMATION_ROUTES,
        canActivate: [subscriptionGuard, subscriptionLevelGuard],
    },
    {
        path: MAIN_SLUGS.TEMPLATES,
        children: TEMPLATES_ROUTES,
    },
    {
        path: MAIN_SLUGS.TICKET,
        children: TICKET_ROUTES,
        canActivate: [subscriptionGuard],
    },
    ...AGENT_CHAT_ROUTE,
    //
    {
        path: SETTINGS_SLUGS.checkout,
        title: 'Checkout',
        loadComponent: () =>
            import('@features/settings/checkout-page/checkout.component').then(
                m => m.CheckoutComponent
            ),
    },
    //
    { path: MAIN_SLUGS.NOT_FOUND, title: 'Page not found', component: PageNotFoundComponent },
];
